import { notify } from 'utils/reduxUtils';

export const types = {
  CLOSE: 'common/modals/purchasedComponentUpdateCreateModal/CLOSE',
  DELETE_ERROR:
    'common/modals/purchasedComponentUpdateCreateModal/DELETE_ERROR',
  DELETE_REQUEST:
    'common/modals/purchasedComponentUpdateCreateModal/DELETE_REQUEST',
  DELETE_SUCCESS:
    'common/modals/purchasedComponentUpdateCreateModal/DELETE_SUCCESS',
  OPEN_ERROR: 'common/modals/purchasedComponentUpdateCreateModal/OPEN_ERROR',
  OPEN_REQUEST:
    'common/modals/purchasedComponentUpdateCreateModal/OPEN_REQUEST',
  OPEN_SUCCESS:
    'common/modals/purchasedComponentUpdateCreateModal/OPEN_SUCCESS',
  SAVE_ERROR: 'common/modals/purchasedComponentUpdateCreateModal/SAVE_ERROR',
  SAVE_REQUEST:
    'common/modals/purchasedComponentUpdateCreateModal/SAVE_REQUEST',
  SAVE_SUCCESS:
    'common/modals/purchasedComponentUpdateCreateModal/SAVE_SUCCESS',
  SET_CUSTOM_COLUMNS:
    'common/modals/purchasedComponentUpdateCreateModal/SET_CUSTOM_COLUMNS',
  SET_PRODUCT: 'common/modals/purchasedComponentUpdateCreateModal/SET_PRODUCT',
  SET_PURCHASED_COMPONENT:
    'common/modals/purchasedComponentUpdateCreateModal/SET_PURCHASED_COMPONENT',
};

export const purchasedComponentUpdateCreateModal = {
  close: () => ({
    type: types.CLOSE,
  }),
  setCustomColumns: ({ customColumns }) => ({
    type: types.SET_CUSTOM_COLUMNS,
    payload: { customColumns },
  }),
  setProduct: ({ product }) => ({
    type: types.SET_PRODUCT,
    payload: { product },
  }),
  setPurchasedComponent: ({ purchasedComponent }) => ({
    type: types.SET_PURCHASED_COMPONENT,
    payload: { purchasedComponent },
  }),
};

export const open = {
  error: notify(
    (error) => ({
      type: types.OPEN_ERROR,
      payload: error,
    }),
    'Failed to edit purchased component',
  ),
  request: ({
    deleteCallBack,
    purchasedComponentId,
    productId,
    prefilledOemPartNumber,
    mode,
    saveCallBack,
  }) => ({
    type: types.OPEN_REQUEST,
    payload: {
      deleteCallBack,
      purchasedComponentId,
      productId,
      prefilledOemPartNumber,
      mode,
      saveCallBack,
    },
  }),
  success: () => ({
    type: types.OPEN_SUCCESS,
  }),
};

export const save = {
  error: notify(
    (error) => ({
      type: types.SAVE_ERROR,
      payload: error,
    }),
    'Failed to save purchased component',
  ),
  request: ({
    description,
    internalPartNumber,
    oemPartNumber,
    piecePrice,
    productId,
    properties,
  }) => ({
    type: types.SAVE_REQUEST,
    payload: {
      description,
      internalPartNumber,
      oemPartNumber,
      piecePrice,
      productId,
      properties,
    },
  }),
  success: ({ purchasedComponent }) => ({
    type: types.SAVE_SUCCESS,
    payload: { purchasedComponent },
  }),
};

export const componentDelete = {
  error: notify(
    (error) => ({
      type: types.DELETE_ERROR,
      payload: error,
    }),
    'Failed to delete purchased component',
  ),
  request: () => ({
    type: types.DELETE_REQUEST,
  }),
  success: ({ purchasedComponentId }) => ({
    type: types.DELETE_SUCCESS,
    payload: { purchasedComponentId },
  }),
};
